var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FEEBF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8009_15754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5962 15.7268L14.4509 5.36621C13.347 3.50293 10.654 3.50293 9.54657 5.36621L3.40478 15.7268C2.27626 17.6252 3.64736 20.0299 5.85517 20.0299H18.1458C20.3536 20.0299 21.7247 17.6252 20.5962 15.7268ZM12.0005 17.7377C11.2727 17.7377 10.6821 17.1471 10.6821 16.4193C10.6821 15.6916 11.2727 15.101 12.0005 15.101C12.7282 15.101 13.3188 15.6916 13.3188 16.4193C13.3188 17.1471 12.7282 17.7377 12.0005 17.7377ZM13.354 9.3459L13.1923 13.1568C13.1642 13.8143 12.6087 14.324 11.9513 14.2959C11.3325 14.2713 10.8368 13.7756 10.8122 13.1568L10.6505 9.3459C10.6118 8.59707 11.1884 7.96074 11.9337 7.92207C12.6825 7.8834 13.3188 8.45996 13.3575 9.20527C13.3575 9.25449 13.3575 9.30019 13.354 9.3459Z",
    fill: "#FD4760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8009_15754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileError);
export default __webpack_public_path__ + "static/media/UploadFileError.27452cc9c75d37594086b74c079b9f1c.svg";
export { ForwardRef as ReactComponent };